import script from "./status.vue?vue&type=script&lang=ts&setup=true"
export * from "./status.vue?vue&type=script&lang=ts&setup=true"

import "./status.vue?vue&type=style&index=0&id=7787db7a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7787db7a"]])

export default __exports__